export default "__VITE_ASSET__761141ae__"